/**
 * Focus Types
 */
export var BROAD_FOCUS = 'broadFocus';
export var MODEL_FOCUS = 'modelFocus';
export var VIN_FOCUS = 'vinFocus';
export var RESEARCHERS = 'researchers';
export var BROWSERS = 'browsers';
export var BUYERS = 'buyers';
export var API_REQUEST = Symbol('API_REQUEST');